import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from './AnimatedList';
import "./Services.css";
import "./ServicePage.css";
import Banner from "../Img/Services Banner/Services Banner.jpg";

function Vessel() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <div className="service-page">
        <section className="service-hero">
          <span className="service-hero__eyebrow">Our Services</span>
          <h1 className="service-hero__title">
            Crane <span>Rentals</span>
          </h1>
          <p className="service-hero__subtitle">
            Reliable crane rental services for heavy-lift, project cargo and industrial
            handling — with trained operators, full safety compliance and rapid mobilisation.
          </p>
        </section>

        <div className="service-layout">
          <article className="service-content">
            <h2>Heavy-Lift Handling, On Demand</h2>
            <p>
              <strong>MMOPL</strong> offers reliable crane rental services for heavy-lift,
              project cargo and industrial handling requirements. Our fleet and partner network
              cover a wide range of crane capacities — suitable for both onshore and offshore
              operations, port handling, construction sites and industrial facilities.
            </p>

            <h2>Trained Operators, Full Compliance</h2>
            <p>
              We provide trained operators, full safety compliance and rapid mobilisation so
              your project stays on schedule. From short-term single-day lifts to long-term
              project rentals, our team works around your timeline and site conditions.
            </p>

            <h2>Our Crane Rentals Cover</h2>
            <ul className="service-features">
              <li>Mobile cranes, crawler cranes and heavy-lift cranes</li>
              <li>Short-term and long-term rental options</li>
              <li>Experienced operators and rigging crews</li>
              <li>On-site project and safety management</li>
              <li>Compliance with local and international safety norms</li>
              <li>Port, offshore and construction-site deployment</li>
            </ul>

            <div className="service-info-banner">
              <div className="service-info-banner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 22V4l18 8" />
                  <path d="M4 4h10" />
                  <line x1="22" y1="12" x2="22" y2="18" />
                  <rect x="19" y="18" width="6" height="4" rx="1" />
                </svg>
              </div>
              <p>
                <strong>Safety-first operations:</strong> Every lift is pre-planned with a
                certified rigging plan and executed under the supervision of a project engineer.
              </p>
            </div>

            <div className="service-cta">
              <h3>Need a Crane on Site?</h3>
              <p>
                Share your lift weight, radius, site conditions and duration —
                we'll recommend the right crane and confirm availability.
              </p>
              <Link to="/Contact" className="service-cta__btn">
                Request Availability
              </Link>
            </div>
          </article>

          <Sidebar />
        </div>
      </div>
    </>
  );
}

export default Vessel;